/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EvmItemActivityListInfo } from '../models/EvmItemActivityListInfo';
import type { EvmTokenHolderListInfo } from '../models/EvmTokenHolderListInfo';
import type { EvmTokenInventoryCountInfo } from '../models/EvmTokenInventoryCountInfo';
import type { EvmTokenInventoryListInfo } from '../models/EvmTokenInventoryListInfo';
import type { EvmTokenItemHolderInfo } from '../models/EvmTokenItemHolderInfo';
import type { EvmTokenItemProfileInfo } from '../models/EvmTokenItemProfileInfo';
import type { EvmTokenOwnerHistoryListInfo } from '../models/EvmTokenOwnerHistoryListInfo';
import type { EvmTokenTransferListInfo } from '../models/EvmTokenTransferListInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class EvmErc721ControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns EvmTokenTransferListInfo OK
     * @throws ApiError
     */
    public getEvmErc721TransferList({
        ca,
        page = 1,
        size = 25,
    }: {
        ca?: string,
        page?: number,
        size?: number,
    }): CancelablePromise<EvmTokenTransferListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/token/ERC721/transfer/list',
            query: {
                'ca': ca,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmTokenTransferListInfo OK
     * @throws ApiError
     */
    public getEvmErc721TransferList1({
        ca,
        page = 1,
        size = 25,
    }: {
        ca?: string,
        page?: number,
        size?: number,
    }): CancelablePromise<EvmTokenTransferListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/token/ERC721/transfer/list',
            query: {
                'ca': ca,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmTokenItemProfileInfo OK
     * @throws ApiError
     */
    public getEvmErc721Profile({
        ca,
        tokenId,
    }: {
        ca: string,
        tokenId: string,
    }): CancelablePromise<EvmTokenItemProfileInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/token/ERC721/item/profile',
            query: {
                'ca': ca,
                'tokenId': tokenId,
            },
        });
    }

    /**
     * @returns EvmTokenItemProfileInfo OK
     * @throws ApiError
     */
    public getEvmErc721Profile1({
        ca,
        tokenId,
    }: {
        ca: string,
        tokenId: string,
    }): CancelablePromise<EvmTokenItemProfileInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/token/ERC721/item/profile',
            query: {
                'ca': ca,
                'tokenId': tokenId,
            },
        });
    }

    /**
     * @returns EvmTokenOwnerHistoryListInfo OK
     * @throws ApiError
     */
    public getEvmErc721OwnerHistoryInfoList({
        ca,
        tokenId,
        page = 1,
        size = 10,
    }: {
        ca: string,
        tokenId: string,
        page?: number,
        size?: number,
    }): CancelablePromise<EvmTokenOwnerHistoryListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/token/ERC721/item/holder/history/list',
            query: {
                'ca': ca,
                'tokenId': tokenId,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmTokenOwnerHistoryListInfo OK
     * @throws ApiError
     */
    public getEvmErc721OwnerHistoryInfoList1({
        ca,
        tokenId,
        page = 1,
        size = 10,
    }: {
        ca: string,
        tokenId: string,
        page?: number,
        size?: number,
    }): CancelablePromise<EvmTokenOwnerHistoryListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/token/ERC721/item/holder/history/list',
            query: {
                'ca': ca,
                'tokenId': tokenId,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmTokenItemHolderInfo OK
     * @throws ApiError
     */
    public getEvmErc721ItemHolderInfo({
        ca,
        tokenId,
    }: {
        ca: string,
        tokenId: string,
    }): CancelablePromise<EvmTokenItemHolderInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/token/ERC721/item/holder',
            query: {
                'ca': ca,
                'tokenId': tokenId,
            },
        });
    }

    /**
     * @returns EvmTokenItemHolderInfo OK
     * @throws ApiError
     */
    public getEvmErc721ItemHolderInfo1({
        ca,
        tokenId,
    }: {
        ca: string,
        tokenId: string,
    }): CancelablePromise<EvmTokenItemHolderInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/token/ERC721/item/holder',
            query: {
                'ca': ca,
                'tokenId': tokenId,
            },
        });
    }

    /**
     * @returns EvmItemActivityListInfo OK
     * @throws ApiError
     */
    public getEvmErc721ItemActivityInfoList({
        ca,
        tokenId,
        page = 1,
        size = 25,
    }: {
        ca: string,
        tokenId: string,
        page?: number,
        size?: number,
    }): CancelablePromise<EvmItemActivityListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/token/ERC721/item/activity/list',
            query: {
                'ca': ca,
                'tokenId': tokenId,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmItemActivityListInfo OK
     * @throws ApiError
     */
    public getEvmErc721ItemActivityInfoList1({
        ca,
        tokenId,
        page = 1,
        size = 25,
    }: {
        ca: string,
        tokenId: string,
        page?: number,
        size?: number,
    }): CancelablePromise<EvmItemActivityListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/token/ERC721/item/activity/list',
            query: {
                'ca': ca,
                'tokenId': tokenId,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmTokenInventoryCountInfo OK
     * @throws ApiError
     */
    public getEvmErc721InventoryListCount({
        ca,
    }: {
        ca: string,
    }): CancelablePromise<EvmTokenInventoryCountInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/token/ERC721/inventory/list/count',
            query: {
                'ca': ca,
            },
        });
    }

    /**
     * @returns EvmTokenInventoryCountInfo OK
     * @throws ApiError
     */
    public getEvmErc721InventoryListCount1({
        ca,
    }: {
        ca: string,
    }): CancelablePromise<EvmTokenInventoryCountInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/token/ERC721/inventory/list/count',
            query: {
                'ca': ca,
            },
        });
    }

    /**
     * @returns EvmTokenInventoryListInfo OK
     * @throws ApiError
     */
    public getEvmErc721InventoryList({
        ca,
        page = 1,
        size = 15,
    }: {
        ca: string,
        page?: number,
        size?: number,
    }): CancelablePromise<EvmTokenInventoryListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/token/ERC721/inventory/list',
            query: {
                'ca': ca,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmTokenInventoryListInfo OK
     * @throws ApiError
     */
    public getEvmErc721InventoryList1({
        ca,
        page = 1,
        size = 15,
    }: {
        ca: string,
        page?: number,
        size?: number,
    }): CancelablePromise<EvmTokenInventoryListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/token/ERC721/inventory/list',
            query: {
                'ca': ca,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmTokenHolderListInfo OK
     * @throws ApiError
     */
    public getEvmErc721HolderList({
        ca,
        page = 1,
        size = 25,
    }: {
        ca: string,
        page?: number,
        size?: number,
    }): CancelablePromise<EvmTokenHolderListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/token/ERC721/holder/list',
            query: {
                'ca': ca,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmTokenHolderListInfo OK
     * @throws ApiError
     */
    public getEvmErc721HolderList1({
        ca,
        page = 1,
        size = 25,
    }: {
        ca: string,
        page?: number,
        size?: number,
    }): CancelablePromise<EvmTokenHolderListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/token/ERC721/holder/list',
            query: {
                'ca': ca,
                'page': page,
                'size': size,
            },
        });
    }

}
